
import { Pole } from "../../../types/planBT.types";
import { planBTAPI } from "../../../services/planAPI";

import MicroModalSelectorSearch from "../../../../../common/components/organisme/MicroModalSelectorSearch/MicroModalSelectorSearch";
import useQuerySelector from "../../../../../common/hooks/useQuerySelector";
import { ResponseAPIWithPagination } from "../../../../../common/types/API.types";
import { useEffect } from "react";
import { useSinglePole } from "../../../hooks";



export interface PoleSelectorPresenterProps {
    isError?: boolean ;
    onChange : (pole: Pole) => void;
    value : Pole | null | undefined;
    planId?: string;
    variant?: "dark" | "light";
    initPoleId?: string | null;
    label?: string;
}

export const PoleSelectorPresenter = ({onChange, isError, value, planId, variant, initPoleId, label= "Poteau"} : PoleSelectorPresenterProps) => {

    const {singlePoleQuery,currentPlanId  } = useSinglePole({ poleId: initPoleId, planBTId: planId});

    const  planIdFound =  planId || currentPlanId ;
    useEffect(() => {
        if(singlePoleQuery.data && initPoleId  && !value ){
            onChange(singlePoleQuery.data);
        }
    },[singlePoleQuery.data]) // eslint-disable-line

  const {resultFound, isLoading,  setValueQuery, valueQuery } = useQuerySelector<ResponseAPIWithPagination<Pole>>(
    {
      getSearch : (query: string) => {
        if(planIdFound){
            return  planBTAPI.GetAllPolesFromPlanBT(planIdFound, query);
        }
        //TODO ALL 
        return Promise.resolve(null);
    }}
  );


  



    const onClickItem = (item: any) => {
        onChange(item.item);
    }

    const convertToResultItem = (poles: Pole[]) => {
        return poles.map((pole) => {
            return {
                id: pole.pole_id,
                name: pole.pole_name,
                item: pole
            }
        })
    }


    return <MicroModalSelectorSearch 
        valueSelectedName={value?.pole_name}
        placeholder="Sélectionner un poteau"
        result={  resultFound ? convertToResultItem(resultFound?.data || []) : []}
        setQuery={setValueQuery}
        onClickItem={onClickItem}
        isLoading={isLoading}
        valueQuery={valueQuery}
        isError={isError}
        emptyMessage="Aucun poteau trouvé"
        variant={variant}
        label={label}
    />
};

export default PoleSelectorPresenter;
